<template>
    <v-card>
        <v-card-title>{{name}}</v-card-title>
        <v-card-subtitle>Maschinenring: {{user.pool}}</v-card-subtitle>
        <v-card-text>
            <div>
                <div>
                    <v-icon>mdi-email</v-icon>
                    {{user.email}}
                </div>
                <div>
                    <v-icon>mdi-phone</v-icon>
                    {{user.mobileNumber}}
                </div>
            </div>
        </v-card-text>
        <v-card-actions>
            <v-chip outlined color="green" v-if="user.role === role1().value">
                <v-icon left>mdi-star</v-icon>
                {{$t('key.' + role1().value)}}
            </v-chip>
            <v-chip outlined color="green" v-if="user.role === role2().value">
                <v-icon left>mdi-star-outline</v-icon>
                {{$t('key.' + role2().value)}}
            </v-chip>
            <v-chip outlined color="green" v-if="user.role === role3().value">
                {{$t('key.' + role3().value)}}
            </v-chip>
            <v-spacer></v-spacer>
            <v-btn text icon color="grey darken-2" :to="{name: 'User', params: {userId: user.user_id}}" v-if="authorizedEdit">
                <v-icon color="green">mdi-pencil</v-icon>
            </v-btn>
            <v-btn text icon color="red" @click="onDelete(user.user_id)" v-if="authorizedDelete">
                <v-icon>mdi-delete</v-icon>
            </v-btn>
            <ConfirmDialog ref="confirm"></ConfirmDialog>
        </v-card-actions>
    </v-card>
</template>

<script>
    import {Roles} from '../../_helpers'
    import ConfirmDialog from '../../base/ConfirmDialog'

    export default {
        name: 'UserCard',
        components: {
            ConfirmDialog
        },
        computed: {
            name() {
                return `${this.user.firstName} ${this.user.lastName}`
            },
            authorizedEdit() {
                // List of items is already filtered; only an authenticated user is allowed to edit users
                return this.$store.getters.isAuthenticated
            },
            authorizedDelete() {
                let userProfile = this.$store.getters.userProfile

                // Only an authenticated user with SUPERADMIN role is allowed to delete users
                return this.$store.getters.isAuthenticated && userProfile.role === Roles.ROLE_1.value
            }
        },
        props: ['user'],
        methods: {
            role1() {
                return Roles.ROLE_1
            },
            role2() {
                return Roles.ROLE_2
            },
            role3() {
                return Roles.ROLE_3
            },
            onDelete(userId) {
                // Open confirmation dialog
                this.$refs.confirm.open(
                    this.$t('key.deleteUserTitle'),
                    this.$t('key.deleteUserText', {'0': this.name}), { color: 'red' })
                    .then((confirm) => {
                        if (confirm) {
                            this.$store.dispatch('deleteUser', userId)
                        }
                    })
            }
        }
    }
</script>

<style>

</style>
